import { __extends } from "tslib";
import * as ioTypes from "./io/Types";
import { deserializeNode, serializeNode } from "./io/Serialization";
import { SceneElement } from "./SceneElement";
/**
 * A simple graphical scene element which supports serialization.
 * E.g. can be used for imported models.
 */
var BasicElement = /** @class */ (function (_super) {
    __extends(BasicElement, _super);
    function BasicElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BasicElement.prototype.clone = function (pNewParent) {
        var tClone = new BasicElement(this.mModel, SceneElement.cloneNode(this.mNode, pNewParent));
        return (tClone);
    };
    BasicElement.prototype.serialize = function (pContext) {
        if (this.mNode == null)
            return (null);
        var tIOElement = {};
        tIOElement.classId = ioTypes.BASIC_ELEMENT_CLASSID;
        tIOElement.node = serializeNode(this.mModel, pContext, this.mNode);
        return (tIOElement);
    };
    //// internal //////////////////////////////////////////////////////////////////////////////
    /** @internal */
    BasicElement._RegisterClass = function (pModel) {
        pModel.registerElementLoader(ioTypes.BASIC_ELEMENT_CLASSID, function (pApp, pContext, pIOElement, pParentGroup) {
            if (pIOElement == null)
                return (null);
            var tIOElement = pIOElement;
            var tNode = deserializeNode(pApp.model, pContext, tIOElement.node, pParentGroup != null ? pParentGroup.node : null);
            if (tNode == null)
                return (null);
            return (new BasicElement(pApp.model, tNode));
        });
    };
    return BasicElement;
}(SceneElement));
export { BasicElement };
